import Logger from 'js-logger';

Logger.useDefaults();

export {Logger};
